<template>
  <div>
    <loader-component v-if="loaderState"/>
    <install-app v-if="appInstallPopup" :popupState="appPopup"/>
    <header-block/>
    <router-view/>
    <popup-selector v-if="isPopUpActive"/>
  </div>
</template>
<script>

import HeaderBlock from '@/views/header-block';
import PopupSelector from '@/views/popup-selector';
import { mapGetters, mapState } from 'vuex';
import LoaderComponent from '@/views/loader-component';
import InstallApp from '@/components/popUp/install-app'
import { getUserCards, getUserData } from '@/requests/kariRequests'
export default {
  components: { InstallApp, LoaderComponent, PopupSelector, HeaderBlock },
  data () {
    return {
      appPopup: false
    }
  },
  computed: {
    appInstallPopup () {
      return window.matchMedia('(max-width: 767px)').matches
    },
    ...mapState({
      isPopUpActive: state => state.isPopUpActive,
      loaderState: state => state.loading
    }),
    ...mapGetters(['isAuthenticated'])
  },
  watch: {
    isAuthenticated: function (newValue, oldValue) {
      if (oldValue === true && newValue === false) {
        document.location.reload();
      }
    }
  },
  async mounted () {
    setTimeout(() => {
      this.appPopup = true
    }, 1000)
    if (this.isAuthenticated) {
      console.log('if isAuthenticated true')
      const instalment = await this.$store.dispatch('getInstallments');
      if (instalment) {
        console.log('instalment true');
        await getUserData().then(async (res) => {
          this.$store.dispatch('splitNameBeforeSave', res);
          await getUserCards().then((res) => {
            this.$store.dispatch('prepareCardsInfo', res);
            this.$store.commit('showLoader', false);
          }).catch(() => {
            console.log('cardsCatch')
          });
        });
      }
    }
    if (process.env.NODE_ENV !== 'development') {
      const s = document.createElement('script');
      s.async = true;
      s.src = 'https://cdn-ru.bitrix24.ru/b13445916/crm/site_button/loader_10_mizfw8.js' + '?' + (Date.now() / 60000 | 0);
      document.head.appendChild(s);
    }
  }
};
</script>

<style>
@font-face {
  font-family: 'circeregular2'; src: url('../src/assets/fonts/circe-regular-webfont.woff2') format('woff2'), url('../src/assets/fonts/circe-regular-webfont.woff') format('woff'); font-weight: normal; font-style: normal }

@font-face {
  font-family: 'circeregular'; src: url('../src/assets/fonts/circe-webfont.woff2') format('woff2'), url('../src/assets/fonts/circe-webfont.woff') format('woff'); font-weight: normal; font-style: normal }

@font-face {  font-family: 'inter';  src: url('../src/assets/fonts/inter_extra_bold_regular-webfont.woff2') format('woff2'), url('../src/assets/fonts/inter_extra_bold_regular-webfont.woff') format('woff');  font-weight: bold;  font-style: normal }

/*выравнивание блоков*/
.align { width: 91.47vw; margin: 0 auto }
.alignMid { width: auto; margin: 0 auto }
.alignSmall { width: auto; margin: 0 auto }

#app {
  font-family: 'circeregular2';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/*кнопки*/
.purpleButton {background-color: rgba(153, 30, 102, 1); color: white; border-radius: 8px; font-size: 4.53vw; border: 1px solid rgba(153, 30, 102, 1); cursor: pointer; font-weight: 700; font-family: 'circeregular2'}
.purpleButton>a {color: white; font-weight: 700; text-decoration-line: none}
.whiteButton { border: 1px solid rgba(153, 30, 102, 1); color: rgba(153, 30, 102, 1); border-radius: 8px; font-size: 4.53vw; cursor: pointer; font-weight: 700; font-family: 'circeregular2' }
.whiteButton>a { color: rgba(153, 30, 102, 1); font-weight: 700; text-decoration-line: none }

input { padding: 0; border: none; margin: 0 }
h1 {font-size: 6.40vw; margin: 0}
h2 {font-size: 5.87vw; margin: 0}
h3 {font-size: 5.33vw; margin: 0}
p { margin: 0; font-size: 4.27vw }
.PC {display: none}
.mobile {display: block}
body { margin: 0; font-family: 'circeregular2' }
a { cursor: pointer }

/*общие стили формы регистрации, реквизитов, входа, смс*/
.logReg { position: relative; padding: 5.33vw 0; width: 89.33vw }
.logReg>.title { margin-bottom: 5.87vw }
.logReg>.title>p { color: rgba(114, 114, 114, 1)}
.logReg>.cross { position: absolute; right: -1.8vw; top: 4.4vw; font-size: 3.20vw; color: rgba(153, 159, 163, 1); text-decoration-line: none; font-weight: 700; cursor: pointer; height: 8.53vw; width: 8.53vw}

/*общие стили попап окон*/
#popUpWin { padding: 5.33vw; background-color: rgba(255, 255, 255, 1); box-shadow: 0 0 2.67vw 0 rgba(0, 0, 0, 0.25); border-radius: 8px; width: calc(100% - 10.67vw) }
#popUpWin>div>.cross { display: flex; justify-content: flex-end; margin-bottom: 4.27vw }
#popUpWin h1 { font-weight: 400 }
#popUpWin>div>.imgBlock { display: flex; flex-direction: column; align-items: center; height: 102.13vw; justify-content: center; }
#popUpWin>div>.imgBlock>img { margin-bottom: 2.13vw }

/*форма регистрации*/
#registr {}
#registr>.agreement { margin-bottom: 5.33vw; margin-top: 10.67vw; display: flex; align-items: center }
#registr>.agreement>.oferta>a { color: rgba(153, 30, 102, 1); text-decoration-line: underline }
#registr>.recoverPass {display: flex }
#registr>.recoverPass>p { margin-right: 5.60vw; color: rgba(114, 114, 114, 1)}
#registr>.recoverPass>a { color: rgba(153, 30, 102, 1); text-decoration-line: underline }
#registr>.purpleButton { padding: 4.27vw 0; width: 201px; margin-bottom: 6.40vw }

@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  input {}
  h1 {font-size: 42px; margin: 0}
  h2 {font-size: 36px; margin: 0}
  h3 {font-size: 22px; margin: 0}
  h4 {font-size: 22px; margin: 0}
  p { margin: 0; font-size: 18px }
  .PC {display: block}
  .mobile {display: none}
  body {}

  /*выравнивание блоков*/
  .align { width: 1160px; margin: 0 auto }
  .alignMid { width: 780px; margin: 0 auto }
  .alignSmall { width: 590px; margin: 0 auto }

  /*кнопки*/
  .purpleButton {background-color: rgba(153, 30, 102, 1); color: white; border-radius: 12px; font-size: 17px; border: 1px solid rgba(153, 30, 102, 1); cursor: pointer; font-weight: 700; font-family: 'circeregular2'}
  .whiteButton { border: 1px solid rgba(153, 30, 102, 1); color: rgba(153, 30, 102, 1); border-radius: 12px; font-size: 16px; cursor: pointer; font-weight: 700; font-family: 'circeregular2' }

  /*общие стили попап окон*/
  #popUpWin { padding: 20px; background-color: rgba(255, 255, 255, 1); box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25); border-radius: 8px }
  #popUpWin>div>.cross { display: flex; justify-content: flex-end; margin-bottom: 25px; cursor: pointer }
  #popUpWin h1 { font-weight: 400; font-size: 30px }
  #popUpWin>div>.imgBlock { height: 190px }
  #popUpWin>div>.imgBlock>img {}

  /*общие стили формы регистрации, реквизитов, входа, смс*/
  .logReg { padding: 60px 0 }
  .logReg>.purpleButton { padding: 16px 0; width: 233px }
  .logReg>.title { margin-bottom: 22px }
  .logReg>.title>p {}
  .logReg>.cross { right: 0; top: 61px; cursor: pointer; height: 32px; width: 32px }

  /*форма регистрации*/
  #registr {}
  #registr>.kariInput {margin-bottom: 8px}
  #registr>.agreement { margin-bottom: 34px; margin-top: 34px; display: flex; align-items: center }
  #registr>.agreement>.oferta>a {}
  #registr>.recoverPass { margin-bottom: 80px }
  #registr>.recoverPass>p { margin-right: 23px }
  #registr>.recoverPass>a {}
  #registr>.purpleButton { padding: 16px 0; width: 201px; margin-bottom: 34px }

}
</style>
